/**
 * React Query Client Configuration
 * Centralized configuration for all queries
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 5 minutes
      staleTime: 1000 * 60 * 5,

      // Cache time: 10 minutes
      gcTime: 1000 * 60 * 10,

      // Retry failed requests
      retry: 1,

      // Refetch on window focus
      refetchOnWindowFocus: true,

      // Refetch on mount if data is stale
      refetchOnMount: true,

      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});
